.meetTheDreamTeamSection {
    background-color: #e7f4f5;
    text-align: center;
    padding-top: 110px;
    padding-bottom: 143px;
}

@media (max-width: 500px) {
    .meetTheDreamTeamSection {
        padding-top: 131px;
        padding-bottom: 119px;
    }
}

.uppercaseSubheading {
    font-size: 19px;
    text-transform: uppercase;
    color: #3caeb0;
    letter-spacing: 1px;
    font-weight: bold;
}

.heading {
    font-size: 32px;
    line-height: 1.1em;
    color: #3caeb0;
    font-weight: bold;
}


.form {
    padding: 48px 0;
}

.inlineLink {
    color: inherit;
    text-decoration: underline;
}

.inlineLink:hover {
    color: #3caeb0;
}

.meetTheDoctorContainerOuter {
    background-color: white;
}

.meetDrCompanioniOuter {
    background-color: #e7f4f5;
}

.quoteBoxWithTopArrow {
    background-color: #3caeb0;
    position: relative;
    margin-bottom: 20px;
}

.quoteBoxWithTopArrow::before {
    content: '';
    position: absolute;
    top: -10px;
    left: 4px;
    width: 20px;
    height: 20px;
    transform: rotate(45deg);
    background: #3caeb0;
}

.quoteText {
    line-height: 1.55em;
    color: white;
}

.meetTheDoctorContainer {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 32px;
    max-width: 1100px;
    padding-right: 20px;
    padding-left: 20px;
    width: 100%;
}

.wideDoctorContainer {
    max-width: 1250px;
}

.doctorImage {
    width: min(360px, calc(100vw - 70px));
}

.meetTheDoctorContainer p,
.meetTheDoctorContainer li {
    line-height: 1.55em;
}

.drGarciaPortrait {
    aspect-ratio: 1 / 1;
}

.drChinchillaPortrait {
    aspect-ratio: 2 / 3;
}

.familyImage {
    display: block;
    width: min(360px, calc(100vw - 70px));
    aspect-ratio: 3 / 2;
    height: auto;
    margin: 0 auto;
    object-fit: cover;
}

.chinchillaImageColumn,
.doctorTextColumn {
    flex: 1 1 100%;
}

.meetDrGarcia {
    grid-area: meetDrGarcia;
}

.drGarciaImage {
    grid-area: drGarciaImage;
    flex-shrink: 1;
}

.educationAndExperience {
    grid-area: educationAndExperience;
}

.communityInvolvement {
    grid-area: communityInvolvement;
}

.smilingInMiami {
    grid-area: smilingInMiami;
}

.professionalAffiliations {
    grid-area: professionalAffiliations;
}

@media (max-width: 767px) {
    .meetTheDoctorContainerOuter .meetDrGarcia,
    .meetTheDoctorContainerOuter .educationAndExperience,
    .meetTheDoctorContainerOuter .communityInvolvement,
    .meetTheDoctorContainerOuter .smilingInMiami,
    .meetTheDoctorContainerOuter .professionalAffiliations {
        flex: 0 0 min(360px, calc(100vw - 70px));
    }

    .professionalAffiliations {
        order: 5;
    }

    .smilingInMiami {
        order: 6;
    }
}

.subsectionHeading {
    color: #3caeb0;
    font-size: 32px;
    line-height: 1.1em;
}

.headingDarkBg {
    color: white;
    font-size: 32px;
}

.subsectionHeadingDarkBg {
    color: white;
    font-size: 32px;
    line-height: 1.1em;
}

.heading3 {
    font-size: 20px;
    line-height: 1.1em;
    color: #3caeb0;
    font-weight: bold;
}

.heading3DarkBg {
    font-size: 20px;
    line-height: 1.1em;
    color: white;
    font-weight: bold;
}

@media (min-width: 768px) {
    .heading {
        font-size: 50px;
    }

    .meetTheDreamTeamSection {
        padding-top: 158px;
        padding-bottom: 230px;
    }

    .headingDarkBg {
        font-size: 50px;
    }

    .form {
        padding: 96px 20px;
    }

    .subsectionHeading {
        font-size: 50px;
    }

    .subsectionHeadingDarkBg {
        font-size: 50px;
    }

    .heading3 {
        font-size: 24px;
    }

    .heading3DarkBg {
        font-size: 24px;
    }

    .meetTheDoctorContainer {
        gap: 40px;
        padding-right: 20px;
        padding-left: 20px;
    }

    .meetDrGarcia {
        grid-area: meetDrGarcia;
        flex: 0 1 calc((100% - 40px) / 2);
    }

    .drGarciaImage {
        grid-area: drGarciaImage;
        order: 0;
        flex: 0 1 calc((100% - 40px) / 2);
    }

    .educationAndExperience {
        grid-area: educationAndExperience;
        flex: 0 1 calc((100% - 40px) / 2);
    }

    .communityInvolvement {
        grid-area: communityInvolvement;
        flex: 0 1 calc((100% - 40px) / 2);
    }

    .smilingInMiami {
        grid-area: smilingInMiami;
        flex: 0 1 calc((100% - 40px) / 2);
    }

    .professionalAffiliations {
        grid-area: professionalAffiliations;
        flex: 0 1 calc((100% - 40px) / 2);
        margin-top: -90px;
    }

    .drGarciaPortrait,
    .familyImage {
        width: 100%;
        max-width: 510px;
    }

    .chinchillaImageColumn {
        flex: 0 0 398px;
        order: 2;
    }

    .chinchillaTextColumn {
        order: 1;
    }

    .doctorTextColumn {
        flex: 1 1 0;
    }

    .drChinchillaPortrait {
        width: 398px;
    }

}
